import { render, staticRenderFns } from "./CustomTab.vue?vue&type=template&id=4cb9056a&"
import script from "./CustomTab.vue?vue&type=script&lang=js&"
export * from "./CustomTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports